import firebase from "firebase";
import IdGenerator from "./IdGenerator";
import DailyReportService from "./DailyReportService";
import { ID_NOT_SAVED } from "@/config";

const DAILY_REPORTS = "dailyReports";
const DAILY_REPORT_PREFIX = "DR";

class FirebaseDailyReport {
  constructor() {
    this.$ref = firebase.firestore().collection(DAILY_REPORTS);
  }

  save(dailyReport) {
    // everytime we save, we update the timestamp
    dailyReport.timestamp = new Date().getTime();

    // no id or id == ID_NOT_SAVED means new daily report
    if (!dailyReport.id || dailyReport.id === ID_NOT_SAVED) {
      // newly created entity need to generate new ID
      dailyReport.id = IdGenerator.generate(DAILY_REPORT_PREFIX);
      // because transaction need report id as dailyReportId and comment also
      // contains daily report id, we need to re-collection transactions after
      // generate real dailyReportId
      dailyReport.transactions = DailyReportService.collectTransactions(
        dailyReport
      );
    }

    // use dailyReport's id to save dailyReport
    return this.$ref.doc(dailyReport.id).set(dailyReport);
  }

  remove(id) {
    this.$ref.doc(id).delete();
  }

  // return firebase doc
  find(id) {
    return this.$ref.doc(id).get();
  }

  // return object
  // { docs: firebaseDoc, hasNext: boolean }
  list(size, startAfter = null) {
    // timestamp as order indicator
    // use (size + 1) to find whether there are NEXT page available
    let query = this.$ref
      .orderBy("date", "desc")
      .orderBy("timestamp", "desc")
      .limit(size + 1);

    // if startAfter doc provided, use it
    if (startAfter) {
      query = query.startAfter(startAfter);
    }

    return query.get().then((snapshot) => {
      return {
        docs: snapshot.docs.slice(0, size),
        hasNext: snapshot.docs.length > size,
      };
    });
  }
}

export default new FirebaseDailyReport();
